import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

interface GlitchTextProps {
  text: string;
  className?: string;
  glitchInterval?: number;
}

export function GlitchText({ text, className = '', glitchInterval = 5000 }: GlitchTextProps) {
  const [isGlitching, setIsGlitching] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsGlitching(true);
      setTimeout(() => setIsGlitching(false), 300);
    }, glitchInterval);

    return () => clearInterval(interval);
  }, [glitchInterval]);

  return (
    <motion.span
      className={`relative inline-block ${className}`}
      animate={isGlitching ? {
        x: [0, -2, 2, -2, 2, 0],
        transition: { duration: 0.3 }
      } : {}}
    >
      <span className="relative z-10">{text}</span>
      {isGlitching && (
        <>
          <span
            className="absolute top-0 left-0 text-cyber-cyan opacity-70"
            style={{ clipPath: 'inset(0 0 50% 0)', transform: 'translate(-2px, -1px)' }}
          >
            {text}
          </span>
          <span
            className="absolute top-0 left-0 text-cyber-purple opacity-70"
            style={{ clipPath: 'inset(50% 0 0 0)', transform: 'translate(2px, 1px)' }}
          >
            {text}
          </span>
        </>
      )}
    </motion.span>
  );
}
